<template>
  <div class="content-menu-bar">
    <v-slide-group v-model="bottomNav" class="menu-slide-group" :show-arrows="'mobile'" :mobile-breakpoint="600">
      <v-slide-group-item v-for="(item, idx) in items" :key="idx" v-slot="{ isSelected }" :value="item.value">
        <v-btn
          v-scroll-to="{ el: `#${item.targetID}`, offset: -130 }"
          :value="item.value"
          :active="isSelected"
          height="64"
          class="menu-btn px-4"
          :class="{ '!wd-rounded-none': isSelected }"
          selected-class="menu-btn__actived"
          aria-label="Expan Button"
          variant="text"
        >
          <span :class="{ 'wd-text-orange50': isSelected }"> {{ item.text }} </span>
        </v-btn>
      </v-slide-group-item>
      <template #prev>
        <funnow-icon max-width="20" :image-path="'chevron-left.svg'" />
      </template>
      <template #next>
        <funnow-icon max-width="20" :image-path="'chevron-right.svg'" />
      </template>
    </v-slide-group>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import FunnowIcon from '@/components/icons/funnow-icon'

export default {
  name: 'ContentMenu',
  components: {
    FunnowIcon,
  },
  props: {
    activatedMenu: { type: String, default: '' },
    items: { type: Array, default: () => [] },
  },
  data() {
    return {}
  },
  computed: {
    bottomNav() {
      return this.activatedMenu
    },
    ...mapGetters({}),
  },
}
</script>

<style lang="scss" scoped src="@/assets/sass/navigation/content-menu.scss"></style>
<style lang="scss" src="@/assets/sass/navigation/content-menu--all.scss"></style>
